import SessionService from '../../../services/SessionService';

export default SessionService;
